export const getQuery = state => state.api.query;

export default {
	getQuery,
};
